module.exports = function() {
  return new Worker(__webpack_public_path__ + "9e26b12c38850ec263ce.worker.js");
};